class AutoSelect extends HTMLElement {
  form; selects;
  static selectors = {
    select: '[data-select]'
  }

  constructor() {
    super();
    this.init();
  }

  init = () => {
    this.selects = this.querySelectorAll(AutoSelect.selectors.select);
    this.form = this.querySelector('form');
    
    this.selects.forEach(select => {
      select.addEventListener('change', () => {
        this.onChange();
      });
    });
  }

  onChange = () => {
    if(this.form != undefined){
      window.pageLoader.open();
      this.form.submit();
    }
  }
}
if (!window.customElements.get("auto-select")) {
  window.customElements.define("auto-select", AutoSelect);
}